import * as Scrivito from "scrivito";
import ImageOrVideo from "^/Components/ImageOrVideo";

export const HeroSliderImage = Scrivito.connect(({ panel }) => (
  <ImageOrVideo
    widget={panel}
    teaser={false}
    className="hero-slider-panel-image"
    lazy={false}
  />
));
